export const SUMMERY_REQUEST = "SUMMERY_REQUEST";
export const SUMMERY_SUCCESS = "SUMMERY_SUCCESS";
export const SUMMERY_FAIL = "SUMMERY_FAIL";
